
import { defineComponent } from "vue";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { MenuIcon, XIcon } from "@heroicons/vue/outline";

export default defineComponent({
  name: "TheNavbar",
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    MenuIcon,
    XIcon,
  },

  props: {
    navigation: {
      type: Array,
      required: true,
      validator(
        value: Array<{ name: string; href: string; current: boolean }>
      ): boolean {
        return value.length >= 1;
      },
    },
  },

  emits: ["navigate"],
});
